import React from "react";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  return (
    <div id="body">
      <h1>{t("home.welcomeTitle")}</h1>
      <p>{t("home.welcomeText")}</p>

      <h2>{t("home.exploreTitle")}</h2>
      <p>{t("home.exploreText1")}</p>
      <p>{t("home.exploreText2")}</p>
      <p>{t("home.exploreText3")}</p>

      <h2>{t("home.aboutTitle")}</h2>
      <p>{t("home.aboutText1")}</p>

      <ul>
        <li>{t("home.feature1")}</li>
        <li>{t("home.feature2")}</li>
        <li>{t("home.feature3")}</li>
        <li>{t("home.feature4")}</li>
      </ul>

      <p>{t("home.privacyCommitment")}</p>
    </div>
  );
};

export default Home;
